export default __webpack_public_path__ + "static/media/ANIMATOR_PRZY_KIOSKU.87ad12ff.png";